import React from "react";
import "../Curso.css";

function CursoInfoForm({ curso }) {
  if (!curso) {
    return <div>Cargando...</div>;
  }

  return (
    <div className="curso-info">
      <h5>Información General</h5>

      <div className="curso-info-row">
        <div className="curso-info-label">
          <strong>Fecha de Inicio:</strong>
        </div>
        <div className="curso-info-data">
          {curso.f_inicio ? curso.f_inicio : "-----"}
        </div>
      </div>

      <div className="curso-info-row">
        <div className="curso-info-label">
          <strong>Fecha de Término:</strong>
        </div>
        <div className="curso-info-data">
          {curso.f_termino ? curso.f_termino : "-----"}
        </div>
      </div>

      <div className="curso-info-row">
        <div className="curso-info-label">
          <strong>Formato:</strong>
        </div>
        <div className="curso-info-data">
          {curso.formato ? curso.formato : "-----"}
        </div>
      </div>

      <div className="curso-info-row">
        <div className="curso-info-label">
          <strong>Capacitación:</strong>
        </div>
        <div className="curso-info-data">
          {curso.horas_c ? `${curso.horas_c} hrs` : "-----"}
        </div>
      </div>

      <div className="curso-info-row">
        <div className="curso-info-label">
          <strong>Talleres:</strong>
        </div>
        <div className="curso-info-data">
          {curso.horas_t ? `${curso.horas_t} hrs` : "-----"}
        </div>
      </div>

      <div className="curso-info-row">
        <div className="curso-info-label">
          <strong>Act. Extraprogramáticas:</strong>
        </div>
        <div className="curso-info-data">
          {curso.horas_e ? `${curso.horas_e} hrs` : "-----"}
        </div>
      </div>
    </div>
  );
}

export default CursoInfoForm;
